import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from 'assets/locales/en.json';
import zh from 'assets/locales/zh.json';
import { getConfig } from 'configs';
// import { localStorageService } from 'utils/LocalStorageService';
import { sessionStorageService } from 'utils/SessionStorageService';
import { UseFormReturn } from 'react-hook-form';
import { InternalNamePath } from 'antd/lib/form/interface';
import { FormInstance } from 'antd';
import enLocale from 'antd/es/locale/en_US';
import zhLocale from 'antd/es/locale/zh_HK';

export const ENGLISH_SYMBOL = 'en';
export const CHINESE_SYMBOL = 'zh';
export const LOCAL_SYMBOLS = [ENGLISH_SYMBOL, CHINESE_SYMBOL] as const;

export type I18nSymbol = typeof LOCAL_SYMBOLS[number];

const FALLBACK_LANGUAGE = ENGLISH_SYMBOL;

const resources = {
  en: { ...en, translation: { ...en.translation, cms: {} } },
  zh: { ...zh, translation: { ...zh.translation, cms: {} } },
};

// eslint-disable-next-line
export const revalidateReactFormHook = (methods: UseFormReturn<any>) => {
  methods.trigger(Object.keys(methods.formState.errors));
};

export const revalidateAntdFormLanguageChanged = (form: FormInstance) => {
  const errorFields: InternalNamePath[] = [];
  form?.getFieldsError?.().forEach((field) => field.errors.length && errorFields.push(field.name));
  form?.validateFields(errorFields);
};

const getDefaultLanguage = () => {
  const search = new URLSearchParams(window.location.search);
  const language = [
    //'/privacy-policy', '/terms-and-conditions',
    '/declaration-statement',
    '/genbravo/payment/return',
  ].includes(location.pathname)
    ? search.get('lan')
    : undefined;
  const deviceLocale = language || search.get('language') || navigator.language;

  if (deviceLocale.includes(CHINESE_SYMBOL)) {
    return CHINESE_SYMBOL;
  } else if (deviceLocale.includes(ENGLISH_SYMBOL)) {
    return ENGLISH_SYMBOL;
  } else {
    return FALLBACK_LANGUAGE;
  }
};

const loadCmsI18n = async (symbol: I18nSymbol) => {
  const config = getConfig();

  try {
    const cmsI18nJsonResult = await fetch(`${config.cmsUrl.json.i18n[symbol]}?v=${new Date().valueOf()}`);
    const json = await cmsI18nJsonResult.json();

    resources[symbol].translation = {
      ...resources[symbol].translation,
      cms: json,
    };
  } catch {
    // TODO(Anson Kan): Somehow set fallback value for all of the missing entries?
  }
};

export const initLanguage = async () => {
  // Note(Anson Kan): should be reading the locale setting from BE but we don't seem to have that now
  const lng = sessionStorageService.get('i18nLanguage') || getDefaultLanguage();

  for (const symbol of LOCAL_SYMBOLS) {
    await loadCmsI18n(symbol);
  }

  await i18n.use(initReactI18next).init({
    resources,
    lng,
    fallbackLng: ENGLISH_SYMBOL,
    interpolation: {
      escapeValue: false,
    },
  });
};

export const getAppLocale = (lanuage: string) => {
  return lanuage === ENGLISH_SYMBOL ? enLocale : zhLocale;
};

export default i18n;
